const privacyPolicyBn = {
	breadcrumbs: { home: 'হোম', title: 'প্রাইভেসি পলিসি' },
	hero: {
		title: 'প্রাইভেসি পলিসি',
		subtitle: 'আপনার ব্যক্তিগত তথ্যের নিরাপত্তা ও গোপনীয়তা আমাদের অগ্রাধিকার'
	},
	principles: [
		{ title: 'ডেটা নিরাপত্তা', description: 'আপনার ব্যক্তিগত তথ্য সর্বোচ্চ নিরাপত্তার সাথে সংরক্ষণ করি' },
		{ title: 'স্বচ্ছতা', description: 'কী তথ্য সংগ্রহ করি এবং কেন করি তা স্পষ্টভাবে জানাই' },
		{ title: 'ব্যবহারকারীর নিয়ন্ত্রণ', description: 'আপনার তথ্যের উপর সম্পূর্ণ নিয়ন্ত্রণ আপনার হাতে' },
		{ title: 'গোপনীয়তা সুরক্ষা', description: 'তৃতীয় পক্ষের সাথে অনুমতি ছাড়া তথ্য শেয়ার করি না' }
	],
	dataTypes: [
		{ category: 'ব্যক্তিগত তথ্য', items: ['নাম', 'ফোন নম্বর', 'ইমেইল ঠিকানা', 'জন্ম তারিখ'], purpose: 'অ্যাকাউন্ট তৈরি ও পরিচালনা' },
		{ category: 'ঠিকানার তথ্য', items: ['বাড়ির ঠিকানা', 'ডেলিভারি ঠিকানা', 'উপজেলা', 'জেলা'], purpose: 'পণ্য ডেলিভারি ও স্থানীয় সেবা' },
		{ category: 'পেমেন্ট তথ্য', items: ['মোবাইল ব্যাংকিং নম্বর', 'ব্যাংক অ্যাকাউন্ট', 'লেনদেনের ইতিহাস'], purpose: 'নিরাপদ পেমেন্ট প্রক্রিয়া' },
		{ category: 'ব্যবহারের তথ্য', items: ['অ্যাপ ব্যবহারের ইতিহাস', 'অনুসন্ধান', 'পছন্দের তালিকা'], purpose: 'ব্যক্তিগতকৃত অভিজ্ঞতা প্রদান' }
	],
	usage: {
		title: 'তথ্যের ব্যবহার',
		primaryTitle: 'প্রাথমিক ব্যবহার',
		primary: ['অ্যাকাউন্ট তৈরি ও পরিচালনা', 'অর্ডার প্রক্রিয়াকরণ ও ডেলিভারি', 'কাস্টমার সাপোর্ট প্রদান', 'পেমেন্ট প্রক্রিয়াকরণ'],
		improveTitle: 'উন্নতির জন্য ব্যবহার',
		improve: ['ব্যক্তিগতকৃত সুপারিশ', 'সেবার মান উন্নতি', 'নিরাপত্তা ও জালিয়াতি প্রতিরোধ', 'বাজার গবেষণা ও বিশ্লেষণ']
	},
	rights: {
		title: 'আপনার অধিকারসমূহ',
		items: [
			{ right: 'তথ্য দেখার অধিকার', description: 'আমরা আপনার কী তথ্য সংরক্ষণ করেছি তা জানার অধিকার' },
			{ right: 'তথ্য সংশোধনের অধিকার', description: 'ভুল বা পুরাতন তথ্য সংশোধন করার অধিকার' },
			{ right: 'তথ্য মুছে ফেলার অধিকার', description: 'আপনার ব্যক্তিগত তথ্য মুছে ফেলার অধিকার' },
			{ right: 'তথ্য ডাউনলোডের অধিকার', description: 'আপনার তথ্যের একটি কপি ডাউনলোড করার অধিকার' }
		]
	},
	security: {
		title: 'নিরাপত্তা ব্যবস্থা',
		intro: 'আমরা আপনার তথ্যের নিরাপত্তার জন্য নিম্নলিখিত ব্যবস্থা গ্রহণ করেছি:',
		measures: ['SSL এনক্রিপশন ব্যবহার', 'নিয়মিত নিরাপত্তা অডিট', 'দ্বি-ফ্যাক্টর প্রমাণীকরণ', 'ডেটা ব্যাকআপ ও পুনরুদ্ধার', 'অ্যাক্সেস কন্ট্রোল সিস্টেম', 'নিয়মিত সিস্টেম আপডেট']
	},
	cookies: {
		title: 'কুকিজ নীতি',
		usageTitle: 'কুকিজের ব্যবহার',
		p1: 'আমরা আপনার ব্রাউজিং অভিজ্ঞতা উন্নত করতে এবং আমাদের সেবা ব্যক্তিগতকৃত করতে কুকিজ ব্যবহার করি। কুকিজ হল ছোট টেক্সট ফাইল যা আপনার ডিভাইসে সংরক্ষিত হয়।',
		p2: 'আপনি আপনার ব্রাউজার সেটিংস থেকে কুকিজ নিয়ন্ত্রণ করতে পারেন। তবে কুকিজ বন্ধ করলে আমাদের কিছু সেবা সঠিকভাবে কাজ নাও করতে পারে।'
	},
	sharing: {
		title: 'তৃতীয় পক্ষের সাথে তথ্য শেয়ারিং',
		intro: 'আমরা নিম্নলিখিত ক্ষেত্রে তৃতীয় পক্ষের সাথে তথ্য শেয়ার করতে পারি:',
		authorizedTitle: 'অনুমোদিত শেয়ারিং',
		notDoTitle: 'আমরা যা করি না',
		authorized: ['ডেলিভারি পার্টনারদের সাথে (ঠিকানার জন্য)', 'পেমেন্ট গেটওয়ে (লেনদেনের জন্য)', 'আইনি প্রয়োজনে (আদালতের আদেশে)'],
		notDo: ['বিজ্ঞাপনদাতাদের কাছে বিক্রি করি না', 'অনুমতি ছাড়া মার্কেটিং এ ব্যবহার করি না', 'অপ্রয়োজনীয় তৃতীয় পক্ষের সাথে শেয়ার করি না']
	},
	retention: {
		title: 'তথ্য সংরক্ষণ নীতি',
		retentionTitle: 'সংরক্ষণের সময়সীমা',
		retentionText: 'আমরা আপনার ব্যক্তিগত তথ্য ততক্ষণ পর্যন্ত সংরক্ষণ করি যতক্ষণ আপনার অ্যাকাউন্ট সক্রিয় থাকে বা আমাদের সেবা প্রদানের জন্য প্রয়োজন হয়।',
		deleteTitle: 'তথ্য মুছে ফেলা',
		deleteText: 'অ্যাকাউন্ট বন্ধ করার পর আমরা আইনি প্রয়োজন ছাড়া ৩০ দিনের মধ্যে আপনার সকল ব্যক্তিগত তথ্য মুছে ফেলি।'
	},
	updates: {
		title: 'নীতি আপডেট',
		alert: 'এই প্রাইভেসি পলিসি সময়ে সময়ে আপডেট হতে পারে',
		notify: 'আমরা এই প্রাইভেসি পলিসিতে কোনো পরিবর্তন করলে আপনাকে ইমেইল বা অ্যাপ নোটিফিকেশনের মাধ্যমে জানাবো। গুরুত্বপূর্ণ পরিবর্তনের ক্ষেত্রে আমরা আপনার সম্মতি নেব।',
		lastUpdatedPrefix: 'সর্বশেষ আপডেট:',
		lastUpdatedDate: 'ডিসেম্বর ২০২৩'
	},
	contact: {
		title: 'গোপনীয়তা সংক্রান্ত যোগাযোগ',
		subtitle: 'প্রাইভেসি পলিসি বা আপনার ব্যক্তিগত তথ্য নিয়ে কোনো প্রশ্ন থাকলে আমাদের সাথে যোগাযোগ করুন',
		button: 'যোগাযোগ করুন',
		email: 'privacy@grameenbazar.com'
	}
};

export default privacyPolicyBn;


